import React from "react";
import { Form, Input, Select } from "antd";
import { ReactComponent as DownIcon } from "../../svgs/dropdown_icon.svg";
import { MinusCircleOutlined } from "@ant-design/icons";

const RegistryDetails = ({ registries, isDisabledForm }) => {
  const inputClass = "border-0 border-b-2 rounded-none";
  return (
    <Form.List name="registry_details">
      {(fields, { add, remove }) => (
        <>
          {fields.map(({ key, name, ...restField }, index) => (
            <div className="flex" key={key}>
              <Form.Item
                {...restField}
                className="w-[calc(30%)] mr-6"
                name={[name, "registry_name"]}
                rules={[
                  {
                    required: !isDisabledForm,
                    message: "Please enter Registry Name"
                  }
                ]}
              >
                <Select
                  className="primary_variant"
                  suffixIcon={
                    <DownIcon className="w-[11px] h-[5px] text-[#808080]" />
                  }
                  options={registries}
                  placeholder={"Registry"}
                  disabled={isDisabledForm}
                />
              </Form.Item>
              <Form.Item
                {...restField}
                className="w-[calc(30%)] mr-6"
                name={[name, "registry_username"]}
                rules={[
                  {
                    required: !isDisabledForm,
                    message: "Please enter Registry UserName"
                  }
                ]}
              >
                <Input
                  className={inputClass}
                  placeholder="Registry UserName"
                  disabled={isDisabledForm}
                />
              </Form.Item>
              <Form.Item
                {...restField}
                className="w-[calc(30%)] mr-6"
                name={[name, "registry_id"]}
                rules={[
                  {
                    required: !isDisabledForm,
                    message: "Please enter Registry ID"
                  }
                ]}
              >
                <Input
                  className={inputClass}
                  placeholder="Registry ID"
                  disabled={isDisabledForm}
                />
              </Form.Item>
              <button
                onClick={() => remove(name)}
                disabled={index === 0 || isDisabledForm}
              >
                <MinusCircleOutlined className="m-2" />
              </button>
            </div>
          ))}
          <button
            onClick={() => add()}
            type="button"
            className="w-full h-7 rounded-lg font-bold text-xs flex justify-center items-center 
bg-blue-200 text-blue-800"
            disabled={isDisabledForm}
          >
            + Add Another Registry
          </button>
        </>
      )}
    </Form.List>
  );
};

export default RegistryDetails;
